import { Component, HostBinding, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-environment',
  templateUrl: './environment.component.html',
  styleUrls: ['./environment.component.scss'],
})
export class EnvironmentComponent implements OnInit {
  environment?: string | null;

  @HostBinding('class') class = this.environmentService.isProd()
    ? ''
    : 'env env--not-prod';

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.environment = this.environmentService.environment;
  }
}
